import { fetchJSON } from "./utils";
import { getInitials } from "@/utils/utils";

function formatTeam(team) {
  return {
    ...team,
    shortName: getInitials(team.name),
  };
}

export async function fetchAll(organization_id) {
  const params = {};

  params.organization_id = organization_id;

  const url = `/api/team/`;
  const resp = await fetchJSON(url, params, null, "get", false);
  return resp.data.map(formatTeam);
}

export async function deleteTeam(id) {
  const url = `/api/team/${id}`;
  return fetchJSON(url, null, null, "delete");
}

export async function createTeam(data) {
  const url = `/api/team/`;
  return fetchJSON(url, null, data, "post");
}

export async function updateTeam(id, data) {
  const url = `/api/team/${id}`;
  return fetchJSON(url, null, data, "put");
}
